import { Link } from "react-router-dom"
import { useI18n } from "../i18n/index.tsx"
import { useSession } from "../auth/SessionProvider.tsx"
import { ScanDevices } from "../components/settings/ScanDevices.tsx"
import {
  Card,
  CardHeader,
  DefinitionList,
  Field,
  Icon,
  PageHeader,
  Select,
  Skeleton,
} from "../ui/index.ts"

export function SettingsPage() {
  const { t, locale, setLocale } = useI18n()
  const { user } = useSession()
  if (!user) return <Skeleton lines={3} />

  return (
    <>
      <PageHeader title={t("settings.title")} />

      {/*
        스캐너 기기는 창고(warehouse) 계정만 쓴다 — 화주는 입고 등록을 하지 않으므로
        기기를 묶어도 할 수 있는 일이 없다.
      */}
      {user.role === "warehouse" || user.role === "admin" ? <ScanDevices /> : null}

      <Card>
        <CardHeader title={t("settings.account")} icon="user" />
        <DefinitionList
          rows={[
            { label: t("settings.name"), value: user.name },
            { label: t("settings.id"), value: user.email },
            { label: t("settings.role"), value: t(`role.${user.role}`) },
          ]}
        />
      </Card>

      <Card>
        <CardHeader
          title={t("settings.password")}
          description={t("settings.passwordDesc")}
          icon="lock"
          actions={
            <Link to="/settings/password" className="btn btn--secondary btn--sm">
              <Icon name="lock" size={16} />
              <span>{t("settings.passwordAction")}</span>
            </Link>
          }
        />
      </Card>

      <Card>
        <CardHeader title={t("settings.language")} icon="settings" />
        <Field label={t("settings.language")} htmlFor="locale">
          <Select
            id="locale"
            value={locale}
            onChange={(event) => setLocale(event.target.value as "ko" | "ja")}
          >
            <option value="ko">{t("settings.languageKo")}</option>
            <option value="ja">{t("settings.languageJa")}</option>
          </Select>
        </Field>
      </Card>
    </>
  )
}
